__turbopack_context__.v({
  "mobileAppContainer": "mobileApp-module-scss-module__Yng_bG__mobileAppContainer",
  "mobileAppWrapper": "mobileApp-module-scss-module__Yng_bG__mobileAppWrapper",
});
